import { NgModule } from '@angular/core';
import { MapThreeComponent } from './map-three.component';


@NgModule({
    declarations: [MapThreeComponent],
    exports: [MapThreeComponent]
})
export class MapThreeModule {
}
